<template>
    <div>
        <template v-if="getAmountToPay > 0">
            <label class="box block" v-bind:class="paymentMethod=='windcave' ? 'active' : ''" v-if="paymentInterval() == 'yearly'">
                <input type="radio" name="answer" @change="changePaymentMethod()" v-model="paymentMethod" value="windcave" />
                <WindcavePayment class="block" v-on:success-response-data="setResponseParamsAndRedirectToSuccessPage" />
            </label>
            <label class="box block" v-bind:class="paymentMethod=='onlineeftpos' ? 'active' : ''" v-if="paymentInterval() == 'yearly'">
                <input type="radio" name="answer" @change="changePaymentMethod()" v-model="paymentMethod" value="onlineeftpos" />
                <OnlineEftposPayment v-on:success-response-data="setResponseParamsAndRedirectToSuccessPage" />
            </label>
        </template>
        <template v-else>
            <RefundPayment class="block" v-on:success-response-data="setResponseParamsAndRedirectToSuccessPage" />
        </template>
        <section class="payment_errors notification is-warning mt-5" v-show="this.paymentErrors.length">
            <div :key="error" v-for="error in this.paymentErrors">
                {{ error }}
            </div>
        </section>
        <div class="actions is-flex is-align-items-center is-justify-content-center" v-show="!this.paymentSuccess">
            <button v-if="submittingPayment" class="button is-cta is-large has-text-weight-bold submit is-loading">
            <span class="is-size-6">Submitting payment</span>
            </button>
            <button v-else class="button is-cta is-large has-text-weight-bold submit" @click="getIframe()">
            <span class="icon">
                <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.0528 8.54404H13.4777L13.4741 5.67122C13.4722 2.54312 10.9299 -0.00163256 7.80623 7.85832e-07C4.68254 0.0018236 2.14306 2.54849 2.14376 5.67752L2.1474 8.55034H1.94449C0.869882 8.55126 -0.000907745 9.42353 7.10166e-07 10.5L0.00182053 19.0522C0.00273062 20.1286 0.873518 21.0009 1.94813 21L14.0555 20.9936C15.1301 20.9927 16.0009 20.1204 16 19.044L15.9982 10.4918C15.9991 9.41533 15.1274 8.54305 14.0528 8.54396L14.0528 8.54404ZM8.53333 15.1085L8.53424 17.5312L7.65252 17.5321L7.65162 15.1094C7.16755 14.9298 6.81996 14.4668 6.81996 13.919C6.81905 13.2153 7.38865 12.6439 8.09201 12.6439C8.79445 12.643 9.36496 13.2135 9.36496 13.9181C9.36405 14.465 9.01737 14.928 8.53331 15.1085L8.53333 15.1085ZM11.3905 8.54498L4.23587 8.54862L4.23223 5.6758C4.23132 3.69973 5.83549 2.092 7.80735 2.09107C9.78005 2.09015 11.385 3.69707 11.386 5.6723L11.3905 8.54498Z" fill="white"/>
                </svg>
            </span>
            
            <template v-if="isAltFlow">
                <span v-if="getAmountToPay > 0" class="is-size-6">Pay NZD {{ getAmountToPay | toCurrency }}</span>
                <span v-if="getAmountToPay === 0" class="is-size-6">Submit change</span>
                <span v-if="getAmountToPay < 0" class="is-size-6">Refund NZD {{ getAmountToPay*-1 | toCurrency }}</span>
            </template>
            <span v-else class="is-size-6">Pay NZD {{ getAmountToPay | toCurrency }}</span>
            </button>
        </div>
        <modal
            v-if="modalOpen"
            :class="{ 'is-active': modalOpen }"
            class="modal--is-white modal--has-shadow"
            :large-close-btn="true"
            v-on:childToParent="toggleModal"
        >
            <iframe sandbox="allow-forms allow-scripts allow-popups allow-pointer-lock allow-top-navigation-by-user-activation allow-same-origin" v-bind="envIsLocal && { allow: 'local-network-access *' }" width="100%" :height="dynamicIframeHeight" :src="iframeUrl"></iframe>
            <!--<iframe width="100%" :height="dynamicIframeHeight" :src="iframeUrl"></iframe>-->
        </modal>
    </div>
</template>

<script>
import WindcavePayment from '@/components/partials/WindcavePayment.vue'
import OnlineEftposPayment from '@/components/partials/OnlineEftposPayment.vue'
import RefundPayment from '@/components/partials/RefundPayment.vue'
import { mapGetters } from 'vuex'
import axios from 'axios';
import store, { api } from '../../store/store.js';

export default {
    props: {
        username: String
    },
    data: function () {
        return {
            paymentMethod: 'windcave',
            card: null,
            elementsError: null,
            submittingPayment: true,
            paymentErrors: [],
            paymentSuccess: false,
            modalOpen: false,
            txnid: null,
            iframeUrl: '',
            transactionType: '',
        }
    },
    async mounted() {
        // Allow access from success iframe to call method successParamsFromIframe()
        window.iframe_parent = this;

        if( this.isAltFlow ){
        this.transactionType = 'alt';
        } else if( this.isRenewFlow ){
        this.transactionType = 'renew';
        } else {
        this.transactionType = 'new';
        }
        
        this.paymentMethod = this.getAnswer(this.getStep('payment'),'payment_method') || 'windcave' // default to windcave

        // Store the payment attempt on page load so it's ready to generate the iframe url ( when not a refund )
        if( this.isAnnualAltRefund ){
            this.submittingPayment = false;
        } else {
            //this.savePaymentAttempt();
            this.submittingPayment = false;
        }

    },
    components: {
        WindcavePayment,
        OnlineEftposPayment,
        RefundPayment,
    },
    computed: {
        ...mapGetters({
            answers: 'flattenedAnswers',
            answerLabel: 'getAnswerLabel',
            getAnswer: 'getAnswer',
            sessionId: 'getSessionId',
            getStep: 'getStep',
            client: 'client',
            paymentInterval: 'getPaymentInterval',
            isAltFlow: 'isAltFlow',
            isRenewFlow: 'isRenewFlow',
            isLoggedIn: 'isLoggedIn',
            schemaHash: 'getSessionSchemaHash',
            envIsLocal: 'envIsLocal',
        }),
        getAmountToPay: function(){
            if( "vehicle_quote_adjustment_raw" in this.answers[this.getStep('Vehicle.Quote')] ){
                return this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw;
            } else {
                return this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw;
            }
        },
        isAnnualAltRefund: function(){
            return this.isAltFlow && this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw <= 0;
        },
        dynamicIframeHeight: function(){
            let viewportHeight = window.innerHeight;
            if( viewportHeight >= 1100 ){
                return 1100;
            } else if ( viewportHeight > 500 ){
                return viewportHeight - 100;
            }
            // Max height for mobile
            return 470;
        },
    },
    methods: {
        // this function gets called from our iframe to start redirection to success page
        successParamsFromIframe(iframe_data) {
            this.setResponseParamsAndRedirectToSuccessPage(iframe_data);
        },

        changePaymentMethod: function () {
            
            this.$store.commit('updateBackendData', {
                    [this.getStep('payment')]: {
                        payment_method: this.paymentMethod
                    }
                }
            );
            if( this.isAnnualAltRefund ){
                this.submittingPayment = false;
            } else {
                //this.savePaymentAttempt();
                this.submittingPayment = false;
            }
        },
        
        // getAmountToPay(getAmountToPay){
        //     this.getAmountToPay = getAmountToPay;
        // },
        setResponseParamsAndRedirectToSuccessPage(success_data){
            // Ideally we should be going through standard submit instead of manually adding data here
            let successPage = '';

            successPage = this.getStep('Vehicle.Success');

            store.commit(
                'updateBackendData',
                {[successPage]: success_data}
            );

            store.getters.currentSession.stepPath.push(successPage);

            // Handle new-client flow ( so that the header dashboard button turns up )
            if( ! this.isLoggedIn ){
                this.$store.dispatch('getClientData',{ forceRefresh: true })
            }

            setTimeout(() => {
                // route to next page
                this.$router.push({name: successPage });
                // scroll to top
                window.scrollTo(0,0);
            }, 600); // Give some time to show a success message

        },

        // Note - this method is also called from within the failed payment iframe ( html in src/Controllers/Windcave.php )
        // Handles Windcave response for New/Alt/Renewal
        // TODO - determine why 'vehicle_quote_adjustment_raw' has a historical value
        async savePaymentAttempt(params) {
            try {
                this.paymentErrors = [];
                this.submittingPayment = true;

                if( this.isAltFlow ){
                    params = { adjustment_amount: this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw, ...params};
                }

                let response = await axios.post(api.url + api.version + 'vehicle/' + this.transactionType + '/save-payment-attempt/' + this.$store.state.session_id, {
                    ...params,
                    total_cost_inc_gst: this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw,
                    payment_method: this.paymentMethod,
                    schema_hash: this.schemaHash(),
                });

                if( response.data.results.success ){
                    this.txnid = response.data.results.txnid;
                } else {
                    if (response.data.results.errors) {
                        this.paymentErrors.push(response.data.results.errors);
                    } else {
                        // TODO - show error on front-end
                        this.paymentErrors.push("There was a problem loading the payment processor, please try again or get in touch");
                    }
                }
                this.submittingPayment = false;
            } catch (err) {
                // Handle Error Here
                this.submittingPayment = false;
                return err;
            }
        },

        // Note - this method is also called from within the failed payment iframe ( html in src/Controllers/Windcave.php )
        async getIframe(params){
            try {
                this.submittingPayment = true;
                this.paymentErrors = [];

                // Handle vue.dev mode iframe issue
                if( process.env.NODE_ENV === 'development' ){
                params = { vue_dev_mode_base_url: `${location.protocol}//${window.location.host}`, ...params};
                }

                if( this.isAltFlow ){
                    params = { payment_method: this.paymentMethod, adjustment_amount: this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw, ...params};
                    // vehicle_quote_adjustment_raw
                }

                await this.savePaymentAttempt();

                if ( this.txnid ) {

                    // Handle Annual alt refund endpoint ( No iFrame required )
                    if( this.isAnnualAltRefund ) {

                        let response = await axios.post(`${api.url}${api.version}vehicle/${this.transactionType}/make-annual-refund-payment/${this.$store.state.session_id}`, {
                            ...params,
                            total_cost_inc_gst: this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw,
                            schema_hash: this.schemaHash(),
                        });

                        if( response.data.results.success_data  ){
                            this.paymentSuccess = true;
                            this.successParamsFromIframe(response.data.results.success_data);
                        } else if ( response.data.errors ){
                            this.paymentErrors.push(response.data.errors);
                        } else {
                            this.paymentErrors.push("There was a problem making this refund, please try again or get in touch.");
                        }

                    } else {
                        // Standard iframe endpoint action
                        let iframe_url;
                        if (this.paymentMethod == 'onlineeftpos') {
                            iframe_url = `${api.url}${api.version}vehicle/${this.transactionType}/get-${this.paymentMethod}-payment-id/${this.$store.state.session_id}/${this.txnid}`;
                        } else if (this.paymentMethod == 'windcave') {
                            iframe_url = `${api.url}${api.version}vehicle/${this.transactionType}/get-${this.paymentMethod}-url/${this.$store.state.session_id}/${this.txnid}`;
                        }

                        let response = await axios.post(iframe_url, {
                            ...params,
                            total_cost_inc_gst: this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw,
                            schema_hash: this.schemaHash(),
                        });

                        // create iframe
                        if( ( this.paymentMethod == 'onlineeftpos' && response.data.results.id ) || ( this.paymentMethod == 'windcave' && response.data.results.url ) ){
                            if (this.paymentMethod == 'onlineeftpos') {
                                this.iframeUrl = '/app/payment/onlineeftpos/iframe?payment_id=' + response.data.results.id;
                            } else {
                                this.iframeUrl = response.data.results.url;
                            }
                            this.modalOpen = true;
                        } else if(response.data.results.errors)  {
                            this.paymentErrors.push(response.data.results.errors);
                            this.modalOpen = false;
                        } else {
                            this.paymentErrors.push("There was a problem loading the payment processor, please try again or get in touch");
                            this.modalOpen = false;
                        }

                    }
                }
                this.submittingPayment = false;
            } catch (err) {
                // Handle Error Here
                this.paymentErrors.push("There was a problem loading the payment processor, please try again or get in touch");
                this.modalOpen = false;
                this.submittingPayment = false;
                return err;
            }
        },
        toggleModal: function () {
            this.modalOpen = ! this.modalOpen;
        },
    },

}
</script>
<style scoped lang="scss">


label.box > input {
    margin-right:1rem;
}
label.box {
    display:flex;
    cursor:pointer;    
    border-width: 2px;
    border-radius: 6px;
    align-items:baseline;
}
label.box.active {
    border: 2px solid #82B541;
    box-shadow: 0px 0px 4px 4px rgba(0, 0, 0, 0.05);
}
.payment {
    width:100%;
}

</style>
